// import { useState } from 'react';
// import {
//   ClickOutsideDetector,
//   IconDown,
//   IconSelected,
//   IconUp,
//   IconChart,
//   IconGrid,
// } from '@ui/src/index';
import DashboardTransactions from './transactions';
import DashboardFinancial from './financial';
import DashboardCustomers from './customers';
import DashboardCards from './cards';
import DashboardPaymentTypes from './payment-types';
import { DashboardLeftSideTypes } from './types';

import cn from './dashboard.module.css';

const DashboardLeftSide = ({
  // viewMode,
  // setViewMode,
  // setRightSideVisible,
  transactions,
  cards,
  financial,
  customers,
  setSelectedChart,
  selectedChart,
  paymentTypes,
  cardsEnabled,
}: DashboardLeftSideTypes) => (
  // const [menuVisible, setMenuVisible] = useState(false);

  <div
    // ${viewMode === ViewMode.GRID ? cn.dashboardLeftSideFullWidth : ''}
    className={`${cn.dashboardLeftSide} ${cn.dashboardLeftSideFullWidth}`}
  >
    <div className={cn.dashboardLeftSideTop}>
      {/* <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
          <div className={cn.viewMenuWrapper}>
            <button
              type="button"
              className={`${cn.viewMenuButton} ${
                menuVisible ? cn.viewMenuButtonActive : ''
              }`}
              onClick={() => setMenuVisible(!menuVisible)}
            >
              <div className={cn.menuButtonLeft}>
                <div className={cn.viewMenuButtonIcon}>
                  {viewMode === ViewMode.CHARTS ? <IconChart /> : <IconGrid />}
                </div>
                <div className={cn.viewMenuButtonValue}>
                  {viewMode === ViewMode.CHARTS ? 'Chart view' : 'Grid view'}
                </div>
              </div>
              <div className={cn.menuButtonRight}>
                {menuVisible ? <IconUp /> : <IconDown />}
              </div>
            </button>
            {menuVisible && (
              <ul className={cn.viewMenu}>
                <li className={cn.viewMenuTitle}>Change view</li>
                <li>
                  <button
                    type="button"
                    className={cn.viewModeButton}
                    onClick={() => {
                      setViewMode(ViewMode.CHARTS);
                      setMenuVisible(false);

                      localStorage.setItem('viewMode', ViewMode.CHARTS);
                    }}
                  >
                    <div className={cn.viewModeButtonLeft}>
                      <div className={cn.viewModeButtonIcon}>
                        <IconChart />
                      </div>
                      <div className={cn.viewModeButtonValue}>Chart</div>
                    </div>

                    {viewMode === ViewMode.CHARTS && <IconSelected />}
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className={cn.viewModeButton}
                    onClick={() => {
                      setViewMode(ViewMode.GRID);
                      setMenuVisible(false);

                      localStorage.setItem('viewMode', ViewMode.GRID);
                    }}
                  >
                    <div className={cn.viewModeButtonLeft}>
                      <div className={cn.viewModeButtonIcon}>
                        <IconGrid />
                      </div>
                      <div className={cn.viewModeButtonValue}>Grid</div>
                    </div>
                    {viewMode === ViewMode.GRID && <IconSelected />}
                  </button>
                </li>
              </ul>
            )}
          </div>
        </ClickOutsideDetector> */}
    </div>
    <div
      //  ${viewMode === ViewMode.GRID ? cn.dashboardLeftSideContent : ''}
      className={`${cn.dashboardLeftSideWrapper} ${cn.dashboardLeftSideContent}`}
    >
      <DashboardTransactions
        values={transactions?.values}
        count={transactions?.count}
        // viewMode={viewMode}
        setSelectedChart={setSelectedChart}
        selectedChart={selectedChart}
        // setRightSideVisible={setRightSideVisible}
      />
      <DashboardFinancial
        values={financial?.values}
        // viewMode={viewMode}
        setSelectedChart={setSelectedChart}
        // setRightSideVisible={setRightSideVisible}
        selectedChart={selectedChart}
      />
      <DashboardCustomers
        values={customers?.values}
        // viewMode={viewMode}
        setSelectedChart={setSelectedChart}
        // setRightSideVisible={setRightSideVisible}
        selectedChart={selectedChart}
      />
      <DashboardPaymentTypes
        values={paymentTypes?.values}
        // viewMode={viewMode}
        setSelectedChart={setSelectedChart}
        selectedChart={selectedChart}
        // setRightSideVisible={setRightSideVisible}
      />
      {cardsEnabled && (
        <DashboardCards
          isLoading={cards.isLoading}
          values={cards?.values}
          // viewMode={viewMode}
          setSelectedChart={setSelectedChart}
          // setRightSideVisible={setRightSideVisible}
          selectedChart={selectedChart}
          requestInProgress={cards.requestInProgress}
        />
      )}
    </div>
  </div>
);

export default DashboardLeftSide;
